import { testimonials } from '@/mocks/categories';

export default function Testimonials() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-5 h-5 flex items-center justify-center text-accent-500">
              <i className="ri-shining-fill text-xs"></i>
            </span>
            <span className="text-xs tracking-widest uppercase text-foreground-400 font-medium">Opinie</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            Zaufanie Użytkowników
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="p-6 md:p-7 rounded-2xl bg-background-50/80 border border-background-200/50 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full bg-accent-100 flex items-center justify-center text-sm font-semibold text-accent-600">
                  {t.avatar}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex gap-1 mt-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center text-accent-400">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}